import {
  Route,
  BrowserRouter as Router,
  Switch,
  BrowserRouter,
} from "react-router-dom";
import LoginPage from "../pages/auth/login";
import RegisterPage from "pages/auth/register";
import Carte from "pages/carte";

export default function AuthenticationRouter() {
  return (
    <BrowserRouter>
      <Router>
        <Switch>
          <Route exact path="/auth/register" component={RegisterPage} />
          <Route exact path="/carte/:url" component={Carte} />
          <Route path="/" component={LoginPage} />
        </Switch>
      </Router>
    </BrowserRouter>
  );
}
